const memberRouter = {
  route: null,
  name: null,
  title: '会员管理',
  type: 'folder', // 类型: folder, tab, view
  icon: 'iconfont icon-huiyuanguanli',
  filePath: 'view/member/', // 文件路径
  order: 1,
  inNav: true,
  permission: ['查询所有会员'],
  children: [
    {
      title: '会员列表',
      type: 'view',
      name: 'MemberList',
      route: '/member/list',
      filePath: 'view/member/member-list.vue',
      inNav: true,
      icon: 'iconfont icon-jiemiansheji',
      permission: ['查询所有会员'],
    },
  ],
}

export default memberRouter
